/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import Highcharts, { SeriesOptionsType } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import COLORS from '../../core/constants/colors';
import { LineChartModel } from '../../core/models/chart';

export interface IColumnAxisChart {
  data: LineChartModel[];
}

export default function ColumnAxisChart({ data }: IColumnAxisChart): JSX.Element {
  const forecast = data[0];
  const mean = data[1];

  const chartDataForecast: SeriesOptionsType = {
    name: forecast.marketName,
    type: 'column',
    color: {
      linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
      stops: [
        [0, COLORS.blueGradiendOne],
        [1, COLORS.blueGradiendTwo],
      ],
    },
    tooltip: {
      valueSuffix: forecast.unit,
    },
    data: forecast.chart.map((item) => [item.date, item.value]),
  };

  const chartDataMean = data[1].chart.map((item) => [item.date, item.value]);

  const options: Highcharts.Options = {
    chart: {
      zoomType: 'x',
      animation: false,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: undefined,
    },
    subtitle: {
      text: undefined,
    },
    xAxis: [
      {
        type: 'datetime',
        crosshair: true,
      },
    ],
    yAxis: {
      labels: {
        format: '{value}°C',
      },
      title: {
        text: 'Temperature °C',
      },

      opposite: false,
    },

    // tooltip: {
    //   shared: true,
    // },
    tooltip: {
      // eslint-disable-next-line object-shorthand
      // formatter: function formatter() {
      //   const date = format(this.x, 'EEEE, d LLL yy');
      //   return `<span style="font-size: 11px">${date}</span> <br>
      //           <strong>${this.y.toFixed(1)} °CCCC </strong>`;
      // },
      valueDecimals: 1,
      xDateFormat: '%A, %b %e %Y',
    },
    legend: {
      layout: 'horizontal',
      align: 'left',
      verticalAlign: 'bottom',
      x: 55,
    },
    plotOptions: {
      series: {
        animation: false,
      },
    },
    series: [
      { ...chartDataForecast },
      // Background for main line spline
      {
        name: 'Background Line',
        type: 'spline',
        color: COLORS.white,
        showInLegend: false,
        linkedTo: 'mean',
        showInNavigator: false,
        showCheckbox: false,
        lineWidth: 10,
        data: [...chartDataMean],
        marker: {
          enabled: false,
        },
        tooltip: {
          pointFormat: '',
        },
      },
      // Main line
      {
        name: mean.marketName,
        id: 'mean',
        type: 'spline',
        color: COLORS.red,
        lineWidth: 3,
        marker: {
          enabled: false,
          symbol: 'circle',
        },
        data: [...chartDataMean],
        tooltip: {
          valueSuffix: mean.unit,
        },
      },
    ],
  };
  return (
    <div className="ColumnAxisChart">
      <h3 className="pl-2-8">Temperature UK</h3>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
}
